<omni-loader [background]="true"></omni-loader>
<router-outlet></router-outlet>
